export const selectSyncThemeByResultOfExtractThemeToFileForSync = (state: AppState) => state.syncThemeByResultOfExtractThemeToFileForSync;
